import { render, staticRenderFns } from "./CommCollect.vue?vue&type=template&id=34ba42fe&"
import script from "./CommCollect.vue?vue&type=script&lang=js&"
export * from "./CommCollect.vue?vue&type=script&lang=js&"
import style0 from "./CommCollect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports